import { Box } from '@mui/material'
import React from 'react'

function ReachAfrikaClickAway({ children, onClickAway }) {
    return (
        <>
            {children}
            <Box
                onClick={onClickAway}
                sx={{
                    height: '100vh',
                    width: '100vw',
                    bgcolor: 'rgba(0 , 0 , 0 , .1)',
                    position: 'fixed',
                    zIndex: '10',
                    top: 0,
                    left: 0
                }}
            >
            </Box>
        </>
    )
}

export default ReachAfrikaClickAway